import { render, staticRenderFns } from "./TechnicalFeaturesFoundation.vue?vue&type=template&id=d1601c30"
import script from "./TechnicalFeaturesFoundation.vue?vue&type=script&lang=js"
export * from "./TechnicalFeaturesFoundation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports